module.exports = __webpack_public_path__ + "img/firmatyaRectangulo.701ef19a.png";